export const BASE_FARE = "Base Fare";
export const DUE_AT_PICKUP = "Due at Pick-up";
export const TAXES_AND_FEES = "Taxes & Fees";
export const TRIP_TOTAL = "Total";
